export default __webpack_public_path__ + "static/media/Hajj_content.490e661e.svg";